export default __webpack_public_path__ + "static/localhostacademy-720d92b75ce2b6bf1f45e93323a11f90.png";